<template>
  <div>
    <v-alert v-if="isKonfirmasi && $getDeepObj(pspSimulasi, 'tgl_simulasi')" icon="mdi-information" text type="info">
      Jadwal Simulasi Mengajar dan Wawancara Anda
      <b>( {{ $localDate($getDeepObj(pspSimulasi, 'tgl_simulasi')) }} )</b> pada
      <b>
        Sesi {{ $getDeepObj(pspSimulasi, 'slot') }} ({{ $localTime($getDeepObj(pspSimulasi, 'jam_mulai')) }} WIB -
        {{ $localTime($getDeepObj(pspSimulasi, 'jam_selesai')) }}) WIB
      </b>
      <span v-if="!isMulai">
        atau <span class="font-weight-bold red--text">{{ durasi }}</span> lagi
      </span>
    </v-alert>
    <v-alert
      v-else-if="!isKonfirmasi"
      v-show="false"
      icon="mdi-information"
      close-text="Tutup"
      colored-border
      border="left"
      type="info"
      class="bg-notif"
      color="yellow darken-2"
    >
      Anda harus melakuan konfirmasi jadwal sebelum tanggal
      <b>{{ $localDate(tglTutupJadwal) }}</b>
    </v-alert>
    <v-alert v-else icon="mdi-information" text type="info">
      Bapak/Ibu mohon maaf kami sedang dalam proses menjadwalkan seleksi Tahap II untuk Bapak/Ibu kami mohon Bapak/Ibu
      bisa memeriksa SIMPKB secara berkala.
    </v-alert>
    <v-alert v-if="false" class="bg-notif" icon="mdi-information">
      Bapak/ibu, batas waktu membuat dan konfirmasi RPP adalah tanggal
      <b>{{ $localDate(tglTutup, false, true) }}</b
      >, Abaikan informasi ini jika sudah, Terima Kasih.
    </v-alert>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0 black--text">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <v-row dense>
              <v-col cols="12" md="7" sm="12">
                <h1 class="headline info--text">Seleksi Simulasi Mengajar dan Wawancara</h1>
                <div>
                  <b>Seleksi Simulasi Mengajar.</b> Mohon lakukan langkah-langkah berikut sebelum mengikuti seleksi
                  Simulasi Mengajar.
                  <ol>
                    <li>Buat RPP sesuai instruksi.</li>
                    <li
                      >Unggah RPP
                      <a
                        href="https://bantuan.simpkb.id/books/sp-ks-register-sp/ch03/1-1-unggah-rpp.html"
                        target="_blank"
                        >(lihat panduan disini)</a
                      >
                    </li>
                    <li>Konfirmasi waktu pelaksanaan.</li>
                    <li>Sesuai waktu yang telah dikonfirmasi ikuti seleksi Simulasi Mengajar dan Wawancara.</li>
                  </ol>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="infoAsesors.length" class="my-1" dense>
              <v-col v-for="(info, index) in infoAsesors" :key="index" cols="12" md="12" sm="12">
                <v-alert text border="left" colored-border color="blue" dark dense>
                  <div class="pa-2 black--text">
                    <div class="caption">{{ info.title }}</div>
                    <div>
                      <b>{{ $getDeepObj(info, 'nama') || '' }}</b
                      ><br />
                      <template v-if="$getDeepObj(info, 'no_hp')">
                        {{ `+62${Number($getDeepObj(info, 'no_hp'))}` }}
                        <v-icon color="success" small dark @click="onCall(Number($getDeepObj(info, 'no_hp')))">
                          mdi-whatsapp
                        </v-icon>
                      </template>
                      <template v-else-if="$getDeepObj(info, 'no_telpon')">
                        {{ `+62${Number($getDeepObj(info, 'no_telpon'))}` }}
                      </template>
                      <template v-else>-</template>
                    </div>
                    <small class="grey--text">
                      <br />
                      {{ info.desc }}
                    </small>
                  </div>
                </v-alert>
              </v-col>
            </v-row>
            <v-stepper class="my-5" v-model="step" vertical>
              <template v-for="item in stepRpp">
                <div :key="item.value">
                  <v-stepper-step
                    :color="isKonfirmasi ? 'success' : step > item.value ? 'success' : 'primary'"
                    :complete="step > item.value"
                    :step="item.value"
                  >
                    <b>{{ item.label }}</b>
                    <span
                      v-if="step === 3 && item.value === 2"
                      :class="step === 3 && item.value === 2 ? 'warning--text' : ''"
                    >
                      <v-icon v-if="step === 3 && item.value === 2" left color="warning">mdi-book</v-icon>
                      {{ item.desc }}
                    </span>
                    <span v-else class="grey--text" v-html="item.desc" />
                  </v-stepper-step>

                  <v-stepper-content :step="item.value" style="border-left: 1px solid rgba(0, 0, 0, 0.12)">
                    <template v-if="item.value === 1">
                      <div class="blue lighten-5">
                        <v-row>
                          <v-col cols="12" md="2" sm="12">
                            <v-img src="https://penggerak-cdn.siap.id/s3/gurupenggerak/ilust-rpp.png" />
                          </v-col>
                          <v-col cols="12" md="10" sm="10">
                            <h3>BUAT RPP</h3>
                            <div
                              >Silahkan buat RPP anda dan unggah pada aplikasi Guru Berbagi, Untuk membuat RPP anda
                              dapat menekan tombol dibawah ini</div
                            >
                            <v-btn color="primary" depressed small @click="toLink('rpp')">Buat RPP</v-btn>
                            <v-btn color="primary" text link @click="nextStep(item)">SUDAH PUNYA RPP</v-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </template>
                    <template v-else-if="item.value === 2">
                      <v-alert :type="dataRpp.length === 0 ? 'error' : 'info'" dense text>
                        {{
                          dataRpp.length > 0
                            ? 'Sistem mendeteksi RPP yang anda miliki, Silahkan pilih RPP terbaik Anda'
                            : 'Sistem tidak mendeteksi RPP yang anda miliki, silahkan unggah terlebih dahulu pada tautan diatas'
                        }}
                      </v-alert>
                      <div class="grey--text">Pilih RPP yang sudah anda buat</div>
                      <v-select
                        v-model="file_rpp"
                        dense
                        outlined
                        no-data-text="Data RPP tidak ditemukan"
                        :items="modelRpp"
                      />
                      <v-btn color="primary" small :disabled="!file_rpp" @click="konfirmasiRpp">Konfirmasi RPP</v-btn>
                      <v-btn color="primary" small text @click="step--">Unggah RPP</v-btn>
                      <v-btn color="primary" small text @click="step++">Detail Jadwal</v-btn>
                    </template>
                    <template v-else-if="item.value === 3">
                      <template v-if="isPilihJadwal && $getDeepObj(pspSimulasi, 'tgl_simulasi')">
                        <p>
                          Anda sudah diberikan jadwal oleh system untuk melakukan ujian sesi Simulasi Mengajar, jadwal
                          bisa dilihat di bawah ini:
                        </p>
                        <div class="body-1 font-weight-bold my-2"> Jadwal Seleksi Simulasi Mengajar </div>
                        <v-row>
                          <v-col cols="12" md="8" sm="12">
                            <div :class="`pa-3 blue lighten-5`">
                              <v-row>
                                <v-col cols="4">
                                  <b>Hari</b> <br />
                                  <span>
                                    {{
                                      M_HARI[
                                        new Date(
                                          new Date($getDeepObj(pspSimulasi, 'tgl_simulasi')).toLocaleString('en-US', {
                                            timeZone: 'Asia/Jakarta',
                                          })
                                        ).getDay()
                                      ] || '-'
                                    }}
                                  </span>
                                </v-col>
                                <v-col cols="4">
                                  <b>Tanggal</b><br />
                                  <span>{{ $localDate($getDeepObj(pspSimulasi, 'tgl_simulasi')) }}</span>
                                </v-col>
                                <v-col cols="4">
                                  <b>Sesi / Slot</b><br />
                                  <span v-if="$getDeepObj(pspSimulasi, 'slot')">
                                    {{
                                      $getDeepObj(
                                        config,
                                        `peserta.simulasi.${pspProfil.gelombang}.slot.${pspSimulasi.slot}`
                                      ).join(' - ')
                                    }}
                                    WIB
                                  </span>
                                  <span v-else> - </span>
                                </v-col>
                              </v-row>
                            </div>
                            <div class="caption red--text" v-if="isKonfirmasi">
                              <b>Catatan: </b>
                              <span> Pastikan Anda Hadir minimal 15 Menit sebelum Sesi dimulai </span>
                            </div>
                            <p class="my-2"
                              >Semua Waktu Sesi / Slot adalah dalam <b>WIB</b>, Apabila Anda domisili di waktu
                              <b>WIT / WITA</b> maka sesuaikan waktu Anda dengan <b>WIB</b>
                            </p>
                            <a
                              href="https://id.wikipedia.org/wiki/Zona_waktu_Indonesia#:~:text=Indonesia%20terbagi%20atas%20tiga%20zona%20waktu%20yaitu%3A&text=Waktu%20Indonesia%20Tengah%20atau%20WITA,UTC%2B09%3A00)"
                              target="_blank"
                              class="blue--text"
                              >Cek Tautan
                              <span class="font-weight-bold">Wikipedia</span>
                              untuk detil pembagian Zona waktu di indonesia
                            </a>
                          </v-col>
                          <v-col cols="12" md="4" sm="12">
                            <v-img :src="$imgUrl('timezone.jpg')" max-width="400" max-height="300" />
                          </v-col>
                          <v-col cols="12">
                            <v-divider />
                          </v-col>
                          <v-col cols="12">
                            <div v-if="!isKonfirmasi">
                              <v-btn
                                class="mr-1"
                                :disabled="isTutup"
                                color="blue"
                                :dark="!isTutup"
                                @click="onKonfirmasi(1)"
                                >Konfirmasi Jadwal</v-btn
                              >
                              <v-btn color="primary" outlined @click="step--">
                                <v-icon left>mdi-book-remove-multiple</v-icon> Ubah Rpp
                              </v-btn>
                            </div>
                            <div v-else>
                              <v-btn
                                class="mr-1"
                                :disabled="!isPilihRpp"
                                v-if="isKonfirmasi"
                                color="primary"
                                @click="onDetil"
                              >
                                Menuju Simulasi & Wawancara
                              </v-btn>
                              <v-btn color="primary" outlined @click="step--">
                                <v-icon left>mdi-book-remove-multiple</v-icon> Ubah Rpp
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                      </template>
                      <template v-else>
                        <v-alert dense text type="info">
                          Bapak/Ibu mohon maaf kami sedang dalam proses menjadwalkan seleksi Tahap II untuk Bapak/Ibu
                          kami mohon Bapak/Ibu bisa memeriksa SIMPKB secara berkala.
                        </v-alert>
                        <v-btn color="primary" outlined @click="step--">
                          <v-icon left>mdi-book-remove-multiple</v-icon> Ubah Rpp
                        </v-btn>
                      </template>
                    </template>
                  </v-stepper-content>
                </div>
              </template>
            </v-stepper>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <base-modal-full ref="dialog" :title="formulir.title" :useSave="formulir.tipe === 'jadwal'">
      <component
        ref="jadwal"
        :is="formulir.component"
        :tipe="formulir.tipe"
        :initValue="formulir.init"
        :info="formulir.info"
        :configs="configs"
        :infoAsesors="infoAsesors"
        :gpm="'psp_simulasi'"
      />
    </base-modal-full>
    <popup-notifikasi ref="notifikasi" />
    <popup-jadwal
      ref="notifjadwal"
      :wawancara="pspSimulasi"
      :configs="configs"
      :slots="$getDeepObj(config, `peserta.simulasi.1.slot`)"
    />
  </div>
</template>
<script>
import PenjadwalanKandidat from '@components/popup/PenjadwalanKandidat';
import PopupNotifikasi from '@components/popup/Notifikasi';
import PopupJadwal from '@components/popup/KonfirmasiJadwal';
import mixin from './mixin';
import { mapState, mapActions } from 'vuex';
export default {
  mixins: [mixin],
  components: { PenjadwalanKandidat, PopupNotifikasi, PopupJadwal },
  data() {
    return {
      formulir: {},
      autoload: null,
      step: 1,
      dataRpp: [],
      file_rpp: null,
      loading: false,
      mFungsi: {
        1: 'peserta',
        2: 'mentor',
        3: 'fasilitator',
      },
      detail: {},
    };
  },

  computed: {
    ...mapState('preferensi', {
      config: (state) => state.data.config || {},
      pspProfil: (state) => state.data.peserta || {},
      ptk: (state) => state.data.ptk || {},
      wkt_online: (state) => state.wkt_online || null,
    }),

    gelombang() {
      return this.$getDeepObj(this.config, 'peserta.gelombang');
    },

    pspSimulasi() {
      return this.$getDeepObj(this.pspProfil, 'psp_simulasis.0') || {};
    },

    isKonfirmasi() {
      const konfirmasi = this.pspSimulasi?.is_setuju_jadwal ?? null;
      return this.isAutoSubmit ? true : konfirmasi !== null;
    },

    isAutoSubmit() {
      return this.pspSimulasi && this.pspSimulasi.is_setuju_jadwal && Number(this.pspProfil.is_setuju_jadwal) === 0;
    },

    konfirmasi() {
      return Number(this.$getDeepObj(this, 'pspSimulasi.is_setuju_jadwal'));
    },

    isPilihJadwal() {
      return !!this.$getDeepObj(this, 'pspSimulasi.tgl_simulasi');
    },

    tglBuka() {
      return this.$getDeepObj(this, `config.peserta.simulasi.${this.gelombang}.tgl_buka`) || '';
    },

    tglTutup() {
      return this.$getDeepObj(this, `config.peserta.simulasi.${this.gelombang}.tgl_tutup`) || '';
    },

    tglBukajadwal() {
      return this.$getDeepObj(this, `config.peserta.simulasi.${this.gelombang}.tgl_mulai_konfirmasi`) || '';
    },

    tglTutupJadwal() {
      // return this.$getDeepObj(this, `config.peserta.simulasi.${this.gelombang}.tgl_selesai_konfirmasi`) || '';
      return '2021-11-21 23:59';
    },

    isTutup() {
      const now = new Date(this.wkt_online);
      const tutup = new Date(this.tglTutupJadwal);

      return now > tutup;
    },

    durasi() {
      const item = Object.assign({}, this.pspSimulasi);

      const tanggal = this.$getDeepObj(item, 'tgl_simulasi');
      let start = new Date(this.wkt_online);
      let end = new Date(tanggal + ' ' + this.$getDeepObj(item, 'jam_mulai'));
      let diff = end - start;
      let days = Math.floor(diff / 86400000);
      let hours = parseInt((Math.abs(start - end) / (1000 * 60 * 60)) % 24);
      // let minutes = parseInt((Math.abs(start.getTime() - end.getTime()) / (1000 * 60)) % 60)

      return `${days ? days + ' hari' : ''} ${hours ? hours + ' jam' : ''}`;
    },

    isMulai() {
      const item = Object.assign({}, this.pspSimulasi);
      const tanggal = this.$getDeepObj(item, 'tgl_simulasi');
      const now = new Date(this.wkt_online);
      const date = new Date(tanggal + ' ' + this.$getDeepObj(item, 'jam_mulai'));
      return now > date;
    },

    isSelesai() {
      const item = Object.assign({}, this.pspSimulasi);
      const tanggal = this.$getDeepObj(item, 'tgl_simulasi').split(' ')[0];
      const now = new Date(this.wkt_online);
      const date = new Date(tanggal + ' ' + this.$getDeepObj(item, 'jam_selesai'));
      return now > date;
    },

    isAksesWawancara() {
      const item = Object.assign({}, this.pspSimulasi);
      const tanggal = this.$getDeepObj(item, 'tgl_simulasi').split(' ')[0];
      const now = new Date(this.wkt_online);
      const date = new Date(tanggal + ' ' + this.$getDeepObj(item, 'jam_mulai'));

      const open = new Date(date.getTime() - 30 * 60 * 1000);
      return now > open;
    },

    isSelesaiNilai() {
      return false;
    },

    configs() {
      const diff = new Date(this.tglTutup) - new Date(this.tglBuka);
      return {
        title: 'Simulasi Mengajar dan Wawancara',
        tglBuka: this.tglBuka,
        tglTutup: this.tglTutup,
        slot: this.$getDeepObj(this, 'pspSimulasi.slot'),
        tahun: new Date().getFullYear(),
        diff: diff,
        durasi: this.isPilihJadwal ? this.durasi : '',
        isMulai: this.isPilihJadwal ? this.isMulai : '',
        isSelesai: this.isPilihJadwal ? this.isSelesai : '',
        isActiveLink: this.isPilihJadwal ? this.isAksesWawancara : false,
        ptk: this.ptk,
        pspProfil: this.pspProfil,
      };
    },

    stepRpp() {
      const file_rpp = this.file_rpp || '';
      const findRpp = this.dataRpp.find((s) => Number(s.id) === Number(file_rpp)) || {};
      return [
        {
          label: 'Buat RPP',
          value: 1,
          desc: `Tata Cara membuat RPP yang baik dan benar dapat di lihat <a href='https://bantuan.simpkb.id/books/panduan-untuk-guru-dan-relawan-guru-berbagi/ch02/2-2-berbagi-rpp-baru.html' target='_blank'>disini</a>`,
        },
        {
          label: 'Konfirmasi RPP',
          desc: this.step === 3 ? this.$getDeepObj(findRpp, 'judul') || 'Belum Konfirmasi Rpp' : '',
          value: 2,
        },
        { label: 'Konfirmasi Jadwal', value: 3 },
      ];
    },

    modelRpp() {
      const dataRpp = this.dataRpp || [];
      return dataRpp.map((key) => {
        return {
          value: key.id,
          text: key.judul,
        };
      });
    },
    isPilihRpp() {
      const gpmRpp = this.$getDeepObj(this, 'detail.psp_profil_rpps.data') || [];
      return !!Object.keys(gpmRpp).length;
    },

    infoAsesors() {
      let temp = [];
      const profil =
        this.$getDeepObj(this, 'detail.meta.simulasi.akun_penilai.psp_pemantau_asesor_asesor.akun_pemantau') || {};

      temp.push({
        title: 'Tim Pemantau Anda',
        nama: this.$getDeepObj(profil, 'nama') || '',
        no_telpon: '',
        no_hp: this.$getDeepObj(profil, 'no_hp'),
        desc:
          'Silahkan Anda berkonsultasi dengan tim pemantau di atas apabila Anda mengalami (kendala jaringan, kesulitan bergabung di google meet, dan ada musibah) yang dimungkinkan mengganggu pelaksanaan ujian Anda sehingga dibutuhkan penjadwalan ulang',
      });

      return temp;
    },
  },

  created() {
    this.getOnline();
    this.getProfil();
    this.fetchRpp();
  },

  mounted() {
    // this.autoload = setInterval(() => {
    //   this.$store.commit('SET_AUTOSAVE', true)
    //   this.getOnline()
    // }, 5 * 60 * 1000)

    if (this.isSelesaiNilai) {
      const html = `
            <div class="black--text text-center">
                <i class="v-icon mdi mdi-alert-outline theme--light" style="font-size: 80px"></i>
                <h3 class="font-weight-medium">Sesi Ujian Simulasi Mengajar sudah selesai</h3>
            </div>`;
      this.$refs.notifikasi.open(html, 'Informasi');
    }
  },

  methods: {
    ...mapActions('profil', {
      fetchProfil: 'simulasi',
      cekSlot: 'microteaching',
      updateKonfirm: 'konfirmasiSm',
      getRpp: 'getRpp',
      updateRpp: 'konfirmasiRpp',
    }),
    ...mapActions('preferensi', ['getPreferensi', 'getOnline']),
  },

  watch: {
    detail: 'setRpp',
    isTutup(status) {
      if (status && this.isKonfirmasi) {
        this.$set(this, 'step', 3);
      }
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
